export enum ClassId {
    Process = '5e7e5a8ece0014567de5c190',
    Person = '59136a2c116a1f0f8819ecbb',
    Portal = '5edaa23c7f7f6474ee97bbf4'
};